(function () {
  'use strict';

  const root = document.querySelector('.media-page');
  if (!root) return;

  const batchSize = parseInt(root.dataset.batchSize, 10) || 18;
  const grid = root.querySelector('.media-grid');
  const cards = Array.from(grid.querySelectorAll('.media-card'));
  const searchInput = root.querySelector('#media-search-input');
  const typeBoxes = root.querySelectorAll('input[name="type"]');
  const tagBoxes = root.querySelectorAll('input[name="tag"]');
  const dateRadios = root.querySelectorAll('input[name="date"]');
  const clearBtn = root.querySelector('.media-filters__clear');
  const empty = root.querySelector('.media-empty');
  const countEl = root.querySelector('.media-count');
  const sentinel = root.querySelector('.media-sentinel');
  const filtersWrap = root.querySelector('.media-filters');
  const filtersToggle = root.querySelector('.media-filters__toggle');

  let visibleCount = batchSize;
  let filteredCards = cards.slice();

  // Mobile filter drawer
  if (filtersToggle) {
    filtersToggle.addEventListener('click', () => {
      const open = filtersWrap.dataset.open === 'true';
      filtersWrap.dataset.open = open ? 'false' : 'true';
      filtersToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  // Apply prefilter from top "Video" card click
  const initialHash = window.location.hash;
  document.querySelectorAll('[data-prefilter-type]').forEach((el) => {
    el.addEventListener('click', () => {
      const t = el.dataset.prefilterType;
      typeBoxes.forEach((b) => { b.checked = (b.value === t); });
      applyFilters();
    });
  });

  function getCheckedValues(nodeList) {
    return Array.from(nodeList).filter((n) => n.checked).map((n) => n.value);
  }

  function getSelectedDate() {
    const r = Array.from(dateRadios).find((x) => x.checked);
    return r ? r.value : 'all';
  }

  function dateMatches(cardDateStr, mode) {
    if (mode === 'all') return true;
    const cardYear = parseInt(cardDateStr.slice(0, 4), 10);
    const now = new Date();
    const thisYear = now.getFullYear();
    if (mode === 'year') return cardYear === thisYear;
    if (mode === 'lastyear') return cardYear === thisYear - 1;
    if (mode === 'older') return cardYear < thisYear - 1;
    return true;
  }

  function applyFilters() {
    const types = getCheckedValues(typeBoxes);
    const tags = getCheckedValues(tagBoxes).map((t) => t.toLowerCase());
    const dateMode = getSelectedDate();
    const query = (searchInput.value || '').trim().toLowerCase();

    filteredCards = cards.filter((card) => {
      // Type filter (OR within group; if none checked, allow all)
      if (types.length && !types.includes(card.dataset.type)) return false;

      // Tag filter (OR within group; card must have at least one selected tag)
      if (tags.length) {
        const cardTags = (card.dataset.tags || '').split(',').map((t) => t.trim());
        const hit = tags.some((t) => cardTags.includes(t));
        if (!hit) return false;
      }

      // Date filter
      if (!dateMatches(card.dataset.date, dateMode)) return false;

      // Search (title + description blob)
      if (query) {
        const blob = card.dataset.search || '';
        if (!blob.includes(query)) return false;
      }

      return true;
    });

    visibleCount = batchSize;
    render();
  }

  function render() {
    cards.forEach((c) => { c.hidden = true; });
    const slice = filteredCards.slice(0, visibleCount);
    slice.forEach((c) => { c.hidden = false; });

    const total = filteredCards.length;
    const showing = Math.min(visibleCount, total);

    if (total === 0) {
      empty.hidden = false;
      countEl.textContent = '';
    } else {
      empty.hidden = true;
      countEl.textContent = 'Showing ' + showing + ' of ' + total;
    }
  }

  // Debounce search
  let searchTimer = null;
  searchInput.addEventListener('input', () => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(applyFilters, 150);
  });

  typeBoxes.forEach((b) => b.addEventListener('change', applyFilters));
  tagBoxes.forEach((b) => b.addEventListener('change', applyFilters));
  dateRadios.forEach((r) => r.addEventListener('change', applyFilters));

  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      typeBoxes.forEach((b) => { b.checked = false; });
      tagBoxes.forEach((b) => { b.checked = false; });
      dateRadios.forEach((r) => { r.checked = (r.value === 'all'); });
      searchInput.value = '';
      applyFilters();
    });
  }

  // Infinite scroll via IntersectionObserver on the sentinel
  if ('IntersectionObserver' in window && sentinel) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting && visibleCount < filteredCards.length) {
          visibleCount += batchSize;
          render();
        }
      });
    }, { rootMargin: '300px 0px' });
    obs.observe(sentinel);
  }

  render();

  // If page loaded with #media-grid, the browser scrolls automatically.
  // No extra logic needed for the Video top-card jump.
})();